import React from "react";
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="logo">stredisco</div>
      <nav className="nav-links">
        <a href="#">Home</a>
        <a href="#">About</a>
        <a href="#">Wishlist</a>
        <a href="#">Contact</a>
      </nav>
      <button className="login-btn">Login</button>
    </header>
  );
};

export default Header;